import { render, staticRenderFns } from "./verify-bank-account-widget.vue?vue&type=template&id=b4daec0c&"
import script from "./verify-bank-account-widget.vue?vue&type=script&lang=js&"
export * from "./verify-bank-account-widget.vue?vue&type=script&lang=js&"
import style0 from "./verify-bank-account-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports